<ng-container *ngComponentOutlet="componentType$ | async"></ng-container>
